import getHyliaApiClient from 'clients/hylia-api';

export const getPatientUsageReport = async (
  patientId: string,
  accessRightId: string,
): Promise<any> => {
  const api = await getHyliaApiClient();
  const usageReport = await api.getPatientUsageReport(patientId, accessRightId);
  return usageReport.data;
};

export const calendarService = {
  getPatientUsageReport,
};
